// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3TVQn","consentsList":"PatientConsents_consentsList__110td","consentsListEmpty":"PatientConsents_consentsListEmpty__3jdEn"};